<script setup lang="ts">
type IconButtonTone = 'muted' | 'danger';
type IconButtonSize = 'xs' | 'sm' | 'md';

withDefaults(
  defineProps<{
    icon: string;
    tone?: IconButtonTone;
    size?: IconButtonSize;
    tooltip?: string;
    loading?: boolean;
    disable?: boolean;
  }>(),
  {
    tone: 'muted',
    size: 'md',
    tooltip: undefined,
    loading: false,
    disable: false,
  },
);

const emit = defineEmits<{ (e: 'click', payload: Event): void }>();
</script>

<template>
  <q-btn
    :class="['a-icon-button', `a-icon-button--${tone}`]"
    :icon="icon"
    :loading="loading"
    :disable="disable"
    :size="size === 'md' ? undefined : size"
    flat
    round
    dense
    @click="emit('click', $event)"
  >
    <q-tooltip v-if="tooltip">{{ tooltip }}</q-tooltip>
    <slot />
  </q-btn>
</template>

<style scoped lang="scss">
.a-icon-button {
  &--muted {
    color: var(--color-text-muted);
  }
  &--danger {
    color: $error-500;
  }
}
</style>
